export interface ButtonPositionOption {
  value: string;
  label: string;
  kind: "default" | "overlay" | "below";
}

export const DEFAULT_BUTTON_POSITION = "bottom";

// Conjunto completo de posições disponíveis no seletor do admin.
// "bottom" = comportamento atual (botão no rodapé da arte, junto do texto).
// "below" = botão fora da arte, abaixo da imagem.
// Demais = sobreposição sobre a imagem.
export const BUTTON_POSITIONS: ButtonPositionOption[] = [
  { value: "bottom", label: "Padrão (rodapé da arte)", kind: "default" },
  { value: "top-left", label: "Canto superior esquerdo", kind: "overlay" },
  { value: "top-center", label: "Topo centralizado", kind: "overlay" },
  { value: "top-right", label: "Canto superior direito", kind: "overlay" },
  { value: "center-left", label: "Centro à esquerda", kind: "overlay" },
  { value: "center", label: "Centro", kind: "overlay" },
  { value: "center-right", label: "Centro à direita", kind: "overlay" },
  { value: "bottom-left", label: "Canto inferior esquerdo", kind: "overlay" },
  { value: "bottom-center", label: "Centro inferior", kind: "overlay" },
  { value: "bottom-right", label: "Canto inferior direito", kind: "overlay" },
  { value: "below", label: "Abaixo da imagem (fora da arte)", kind: "below" },
];

// Classes de posicionamento absoluto para as posições sobrepostas à arte.
// "bottom" (padrão) e "below" não estão aqui: são tratados de forma especial.
export const OVERLAY_POSITION_CLASSES: Record<string, string> = {
  "top-left": "top-3 left-3",
  "top-center": "top-3 left-1/2 -translate-x-1/2",
  "top-right": "top-3 right-3",
  "center-left": "top-1/2 left-3 -translate-y-1/2",
  center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
  "center-right": "top-1/2 right-3 -translate-y-1/2",
  "bottom-left": "bottom-3 left-3",
  "bottom-center": "bottom-3 left-1/2 -translate-x-1/2",
  "bottom-right": "bottom-3 right-3",
};

// Normaliza o valor vindo do banco para uma posição conhecida.
export function normalizeButtonPosition(value?: string | null): string {
  if (!value) return DEFAULT_BUTTON_POSITION;
  const known = BUTTON_POSITIONS.some((p) => p.value === value);
  return known ? value : DEFAULT_BUTTON_POSITION;
}

export function isOverlayPosition(value?: string | null): boolean {
  return OVERLAY_POSITION_CLASSES[normalizeButtonPosition(value)] != null;
}

export function isBelowPosition(value?: string | null): boolean {
  return normalizeButtonPosition(value) === "below";
}